import React from 'react';
import { getTheme, Stack, Text } from 'office-ui-fabric-react';
import { DefaultButton } from '../Button/Default';
import { SystemPanel } from '../SystemPanel';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const UnauthorizedSplash = _ref => {
  let {
    onLogout
  } = _ref;
  const theme = getTheme();
  return /*#__PURE__*/_jsx(SystemPanel, {
    iconName: "Blocked",
    iconColour: theme.palette.redDark,
    title: "Unauthorised",
    content: /*#__PURE__*/_jsxs(Stack, {
      tokens: {
        childrenGap: 20
      },
      children: [/*#__PURE__*/_jsxs(Text, {
        children: ["Your login does not have any permissions yet.", /*#__PURE__*/_jsx("br", {}), "Please contact lightyear@spafax.atlassian.net"]
      }), onLogout && /*#__PURE__*/_jsx(Stack, {
        horizontal: true,
        children: /*#__PURE__*/_jsx(DefaultButton, {
          onClick: () => {
            onLogout();
          },
          children: "Log Out"
        })
      })]
    })
  });
};